<div class="modal-backdrop">
  <div class="modal-box scrollable">
    <form #macroForm="ngForm">
      <h3>{{ macroPhaseData?.id ? 'Modifica' : 'Nuova' }} Macrofase</h3>

      <label>Nome *</label>
      <input [(ngModel)]="macroPhaseData.name" name="name" required />

      <label>Posizione *</label>
      <input type="number" [(ngModel)]="macroPhaseData.position" name="position" required onwheel="this.blur()" />

      <label>ID WorkType</label>
      <input type="number" [(ngModel)]="macroPhaseData.idWorkType" name="idWorkType" onwheel="this.blur()" />

      <div class="checkbox-row">
        <input type="checkbox" [(ngModel)]="macroPhaseData.isFreeDatas" id="isFreeDatas" name="isFreeDatas" />
        <label for="isFreeDatas">isFreeDatas</label>
      </div>

      <div class="checkbox-row">
        <input type="checkbox" [(ngModel)]="macroPhaseData.isMultiService" id="isMultiService" name="isMultiService" />
        <label for="isMultiService">isMultiService</label>
      </div>

      <div class="checkbox-row">
        <input type="checkbox" [(ngModel)]="macroPhaseData.isActive" id="isActive" name="isActive" />
        <label for="isActive">
          Attiva
          <mat-icon matTooltip="Se attivo: comparirà in preventivazione. Se disattivo: sarà visibile ma non cliccabile."
            fontIcon="info" style="font-size:16px; vertical-align: middle; cursor: pointer; color: #555;">
          </mat-icon>
        </label>
      </div>

      <div class="checkbox-row">
        <input type="checkbox" [(ngModel)]="macroPhaseData.isVisible" id="isVisible" name="isVisible" />
        <label for="isVisible">
          Visibile
          <mat-icon matTooltip="Se visibile: comparirà in preventivazione. Se non visibile: non verrà mostrato."
            fontIcon="info" style="font-size:16px; vertical-align: middle; cursor: pointer; color: #555;">
          </mat-icon>
        </label>
      </div>

      <!-- Avviso -->
      <div *ngIf="macroPhaseData.isActive && !macroPhaseData.isVisible" class="warning-message">
        Attenzione: un elemento attivo ma non visibile non sarà comunque mostrato in preventivazione.
      </div>


      <hr class="section-divider" />

      <label>Codice Nazione</label>
      <input [(ngModel)]="macroPhaseData.codCountry" name="codCountry" readonly />

      <label>Lingua</label>
      <input [(ngModel)]="macroPhaseData.codLanguage" name="codLanguage" readonly />

      <label *ngIf="macroPhaseData.createdAt">Creato il</label>
      <input *ngIf="macroPhaseData.createdAt" [(ngModel)]="macroPhaseData.createdAt" name="createdAt" readonly />

      <label *ngIf="macroPhaseData.updatedAt">Ultima modifica</label>
      <input *ngIf="macroPhaseData.updatedAt" [(ngModel)]="macroPhaseData.updatedAt" name="updatedAt" readonly />

      <div class="modal-buttons">
        <button type="button" (click)="onSave()" [disabled]="!macroForm.form.valid || isUnchanged()">Salva</button>
        <button type="button" (click)="onClose()">Annulla</button>
      </div>
    </form>
  </div>
</div>